export function refineUserData(str) {
    return str.split(" ").join("").toLowerCase();
}